import { render, staticRenderFns } from "./OrderFabricYarnTypeTable.vue?vue&type=template&id=0f971967&"
import script from "./OrderFabricYarnTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricYarnTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports